<template>
  <div class="content-box">
    <div class="outer">
      <div class="title flex justify-content-space-between">
        <span>设备数量分布</span>
        <div style="width:140px;">
          <workshop-selector v-model="workshopid" placeholder="选择车间" size="small" />
        </div>
      </div>
      <div class="center-dash mt">
        <el-row :gutter="20">
          <el-col :span="6">
            <div
              class="dash-item flex align-item-center"
              :class="[activeStatus==3&&'active-item']"
              @click="switchStatus(3)"
            >
              <div class="hd flex-center">
                <div class="dash-dot bg-primary"></div>
              </div>
              <div class="bd pl">运行</div>
              <div class="ft number text-bold font-lg">{{stats.running}}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="dash-item flex align-item-center"
              :class="[activeStatus==4&&'active-item']"
              @click="switchStatus(4)"
            >
              <div class="hd flex-center">
                <div class="dash-dot bg-danger"></div>
              </div>
              <div class="bd pl">告警</div>
              <div class="ft number text-bold font-lg">{{stats.alarm}}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="dash-item flex align-item-center"
              :class="[activeStatus==2&&'active-item']"
              @click="switchStatus(2)"
            >
              <div class="hd flex-center">
                <div class="dash-dot bg-warning"></div>
              </div>
              <div class="bd pl">待机</div>
              <div class="ft number text-bold font-lg">{{stats.standby}}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="dash-item flex align-item-center"
              :class="[activeStatus==1&&'active-item']"
              @click="switchStatus(1)"
            >
              <div class="hd flex-center">
                <div class="dash-dot bg-sec"></div>
              </div>
              <div class="bd pl">停机</div>
              <div class="ft number text-bold font-lg">{{stats.offline}}</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div
        class="center-card-box mt"
        v-loading="loading"
        element-loading-background="rgba(255, 255, 255, 0.1)"
      >
        <el-row :gutter="20">
          <el-col :span="6" v-for="item in showEquip" :key="item.equipid">
            <div class="center-card flip-horizontal-bottom">
              <!--TODO @click="$sdetail(item.stationid)" -->
              <div class="center-hd flex">
                <span class="bd ellipsis">{{item.equip_name}}</span>
                <span class="ft ellipsis" style="max-width:50%">{{item.workshop_title}}</span>
              </div>
              <div
                class="center-bd font-lg"
                :class="[!item.is_online&&'bg-sec',item.is_online && item.is_running && !item.is_alarm&&'bg-primary',item.is_online && item.is_alarm&&'bg-danger',item.is_online && !item.is_running && !item.is_alarm&&'bg-warning']"
              >
                <span v-if="!item.is_online">停机</span>
                <span
                  v-if="item.is_online && item.is_running && !item.is_alarm"
                >{{item.effectiveness + '%'}}</span>
                <span v-if="item.is_online && item.is_alarm">{{item.effectiveness + '%'}}</span>
                <!-- <div v-if="item.is_online && item.is_alarm" class="text-danger mt-xs">{{ item.last_alarm_title }}</div> -->
                <span
                  v-if="item.is_online && !item.is_running && !item.is_alarm"
                >{{item.effectiveness + '%'}}</span>
              </div>
              <div v-if="item.status==1" class="center-ft">
                <i class="iconfont icon-disconnect mr-xs" />
                <span>{{item.last_offline_time | parseTime}}</span>
              </div>
              <div v-if="item.status==2" class="center-ft text-warning">
                <span class="text-warning">待机</span>
              </div>
              <div v-if="item.status==3" class="center-ft text-success">
                <i class="iconfont icon-disconnect mr-xs" />
                <span>{{item.last_offline_time | parseTime}}</span>
              </div>
              <div v-if="item.status==4" class="center-ft">
                <i class="iconfont icon-disconnect mr-xs text-danger" />
                <span>{{item.last_offline_time | parseTime}}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import { mapState, mapGetters } from "vuex";
export default {
  name: "centerContent",
  components: {
    WorkshopSelector: () => import("@/views/sys/components/WorkshopSelector"),
  },
  data() {
    return {
      loading: false,
      // workshopid: null
    };
  },
  computed: {
    ...mapState({
      equips(state) {
        return state.equipStore.allequip;
      },
      pindex(state) {
        return state.equipStore.pindex;
      },
      activeStatus(state) {
        return state.equipStore.status;
      },
      stats(state) {
        return state.equipStore.stats;
      },
    }),
    workshopid: {
      get() {
        return this.$store.state.equipStore.workshopid;
      },
      set(val) {
        store.dispatch("setShopid", val);
      },
    },
    showEquip() {
      return this.$store.getters.showEquip;
    },
  },
  methods: {
    async switchStatus(status) {
      this.loading = true;
      await this.$store.dispatch("setPindex", 0);
      await this.$store.dispatch("setStatus", status);
      this.loading = false;
    },
    // async switchMfgid (workshopid) {
    // 	this.loading = true
    // 	await this.$store.dispatch('setPindex', 0)
    // 	await this.$store.dispatch('setShopid', workshopid)
    // 	this.loading = false
    // },
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  .outer {
    background-color: #252a2f;
    //中心样式
    .title {
      /deep/.el-select {
        background-color: transparent;
        input {
          background-color: transparent;
          color: #07c160;
          border-color: #07c160;
        }
        input::placeholder {
          color: #07c160;
        }
        .el-input__suffix .el-input__suffix-inner::before {
          color: #07c160;
        }
        .el-select__caret {
          color: #07c160;
        }
      }
    }

    .center-dash {
      .dash-item {
        border: 1px solid rgba(255, 255, 255, 0.1);
        height: 60px;
        padding: 10px 5px;
        box-sizing: border-box;
        border-radius: 6px;
        cursor: pointer;
        div {
          line-height: 38px;
        }
        .dash-dot {
          height: 20px;
          width: 20px;
          border-radius: 50%;
        }
      }

      .active-item {
        border-color: #07c160 !important;
      }
    }

    .center-card {
      background-color: rgba(255, 255, 255, 0.1);
      margin-bottom: 20px;
      transition-delay: 0.2s;
      cursor: pointer;
      .center-hd {
        padding: 15px 10px;
        // display: flex;
        // justify-content: space-between;
      }
      .center-bd {
        padding: 20px 10px;
        text-align: center;
        height: 67px;
      }
      .center-ft {
        padding: 5px 10px;
        height: 29px;
        text-align: center;
      }
    }
  }
}

.flip-horizontal-bottom {
  -webkit-animation: flip-horizontal-bottom 0.8s
    cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
  animation: flip-horizontal-bottom 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955)
    both;
}

@-webkit-keyframes flip-horizontal-bottom {
  0% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
  }
  100% {
    -webkit-transform: rotateX(-360deg);
    transform: rotateX(-360deg);
  }
}
@keyframes flip-horizontal-bottom {
  0% {
    -webkit-transform: rotateX(0);
    transform: rotateX(0);
  }
  100% {
    -webkit-transform: rotateX(-360deg);
    transform: rotateX(-360deg);
  }
}
</style>